import { render, staticRenderFns } from "./NewsLayout.vue?vue&type=template&id=462ae919&scoped=true"
import script from "./NewsLayout.vue?vue&type=script&lang=js"
export * from "./NewsLayout.vue?vue&type=script&lang=js"
import style0 from "./NewsLayout.vue?vue&type=style&index=0&id=462ae919&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ae919",
  null
  
)

export default component.exports